import React from 'react';
import { PiGear } from 'react-icons/pi';
import { formatDate } from '../Utils/dateFormatter';

interface SubscriptionDetails {
  status?: string;
  expirationDate?: string;
  next_billing_date?: string;
  scheduledCancelAt?: string | null;
  isScheduledCancel?: boolean;
  subscription_id?: string;
  razorpay_subscription_id?: string;
  id?: string;
}

interface Props {
  subscribeDetails: SubscriptionDetails;
  scheduledCancelAt?: string | null;
  onCancel?: () => void;
  isCancelling?: boolean;
  showCancelButton?: boolean;
}

const SubscriptionStatusDisplay: React.FC<Props> = ({
  subscribeDetails,
  scheduledCancelAt,
  onCancel,
  isCancelling = false,
  showCancelButton = true,
}) => {
  const hasScheduledCancel =
    subscribeDetails?.status === "scheduled_cancel" ||
    Boolean(subscribeDetails?.isScheduledCancel) ||
    Boolean(subscribeDetails?.scheduledCancelAt) ||
    Boolean(scheduledCancelAt);

  const effectiveScheduledCancelAt =
    scheduledCancelAt ??
    subscribeDetails?.scheduledCancelAt ??
    (hasScheduledCancel ? subscribeDetails?.next_billing_date : null) ??
    null;

  const renderStatus = () => {
    if (hasScheduledCancel) {
      return (
        <p className="flex items-center gap-2">
          Scheduled cancel on {formatDate(effectiveScheduledCancelAt)}
        </p>
      );
    }

    switch (subscribeDetails?.status) {
      case 'cancelled':
        return <p className="flex items-center gap-2">Cancelled</p>;

      case 'expired':
        return <p className="flex items-center gap-2">Expired</p>;

      case 'created':
      case 'active':
        return (
          <p className="flex items-center gap-2">
            Renews at {formatDate(subscribeDetails.next_billing_date)}
            {/* {subscribeDetails.next_billing_date && (
              <span className="ml-2 text-xs text-gray-300">
                ({getDaysDifference(subscribeDetails.next_billing_date)} days left)
              </span>
            )} */}
            {showCancelButton && onCancel && (
              <PiGear
                size={30}
                className="cursor-pointer"
                onClick={onCancel}
                style={{
                  pointerEvents: isCancelling ? 'none' : 'auto',
                  opacity: isCancelling ? 0.5 : 1
                }}
              />
            )}
          </p>
        );

      default:
        return null;
    }
  };

  return renderStatus();
};

export default SubscriptionStatusDisplay;
